import { CLessonInCourse, LESSON_STATUS } from '@yandex-int/k-common/typings';
import {
    LESSON_BANNER_VIEW_BADGE_THEME,
    LessonBannerView,
    Link,
    useGeneratePath,
    useIntl,
    Button,
} from 'platform-components/common';
import React from 'react';

import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';
import { getSpecCourseDatesStr } from 'common.components/spec-course/utils';

import './spec-course-lessons.scss';

interface Props {
    clessons: Array<CLessonInCourse>;
    getStatusUtil: (status: LESSON_STATUS) => SPEC_COURSE_LESSON_STATUS;
    onLessonClick: (status: SPEC_COURSE_LESSON_STATUS, lessonId: number) => void;
    lessonUrl: string;
}
export const SpecCourseLessons = ({ clessons, getStatusUtil, onLessonClick, lessonUrl }: Props) => {
    const generatePath = useGeneratePath();
    const intl = useIntl();

    const mapLesson = (clesson: CLessonInCourse) => {
        const images = clesson.lesson.meta.banners_list?.background_img || [];
        const status = getStatusUtil(clesson.status);
        const badgeText = intl.formatMessage({
            id: `specCourse.lesson.statusBadge.${status}`,
        });
        const isInProgress = status === SPEC_COURSE_LESSON_STATUS.IN_PROGRESS;
        const isWaitingForResults = status === SPEC_COURSE_LESSON_STATUS.WAITING_FOR_RESULTS;
        const badgeTheme =
            isInProgress || isWaitingForResults
                ? LESSON_BANNER_VIEW_BADGE_THEME.GREEN
                : LESSON_BANNER_VIEW_BADGE_THEME.BLACK;
        const buttonIdText = intl.formatMessage({
            id: 'specCourse.lesson.buttonText.moreInfo',
        });
        const buttonView = isInProgress ? Button.VIEW.ACTION : Button.VIEW.SECONDARY;
        const { date_assignment: dateAssignment, date_deadline: dateDeadline } = clesson;
        const dateStr = getSpecCourseDatesStr(dateAssignment, dateDeadline, intl);
        const lessonId = clesson.lesson.id;

        return (
            <Link
                isRouter={true}
                key={clesson.id}
                mix="spec-course-lessons__lesson"
                onClick={() => onLessonClick(status, lessonId)}
                theme={Link.THEME.INHERIT}
                to={generatePath(lessonUrl, { clessonId: clesson.id })}
            >
                <LessonBannerView
                    badgeText={badgeText}
                    badgeTheme={badgeTheme}
                    buttonProps={{
                        view: buttonView,
                    }}
                    buttonTextId={buttonIdText}
                    descriptionText={clesson.lesson.meta.readonly_comment || null}
                    headerText={clesson.lesson.name}
                    imageSrc={images[0]}
                    infoText={dateStr}
                />
            </Link>
        );
    };

    return <div className="spec-course-lessons">{clessons.map(mapLesson)}</div>;
};
